import {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import moment from "moment";
import {
  Card,
  Table,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Switch,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup
} from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import personOutline from "@iconify/icons-eva/person-outline";
import {Icon} from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import {alert} from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import TopupDialog from "src/components/dialogs/TopupDialog";
import PointTopupDialog from "./components/PointTopupDialog";
import UserChargeDialog from "src/components/dialogs/UserChargeDialog";
import UIAvatar from "src/components/common/UIAvatar";
import {asyncRequest} from "src/services/network";
import SharesDialog from "src/components/dialogs/SharesDialog";
import UserInfo from "src/components/common/UserInfo";
import PointReleaseDialog from "src/components/dialogs/PointReleaseDialog";
import {ROLE_LEVEL_MAP, ROLE_LEVELS, USER_LEVEL_MAP, USER_LEVELS, USER_STATUS_MAP} from "src/config/constants";
import Label from "src/components/Label";
import BindUserParentDialog from "./components/BindUserParentDialog";
import UserInfoDrawer from "src/components/common/UserInfoDrawer";
import ChangeUserLevelDialog from "./components/ChangeUserLevelDialog";
import UserAddDialog from "./components/UserAddDialog";
import ChangeRoleLevelDialog from "./components/ChangeRoleLevelDialog";
import ResetUserPwdDialog from "./components/ResetUserPwdDialog";
import TxqTopupDialog from "./components/TxqTopupDialog";
import PointTopupDialogTwo from "./components/PointTopupDialogTwo";
import UserMergeDialog from "./components/UserMergeDialog";
import ResetUserPayPwdDialog from "./components/ResetUserPayPwdDialog";
import XfqTopupDialog from "./components/XfqTopupDialog";
import XfqLockedTopupDialog from "./components/XfqLockedTopupDialog";
import UserLiquidateDialog from "./components/UserLiquidateDialog";
import GoldVipTopupDialog from "./components/GoldVipTopupDialog";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip, CircularProgress } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const levels = Object.values(USER_LEVELS);
const roleLevels = Object.values(ROLE_LEVELS);

const TABLE_HEAD = [
  {id: "uid", label: "用户信息", alignRight: false, width: 120},
  {id: "nickname", label: "头像昵称", alignRight: false, width: 150},
  {id: "parent", label: "推荐人", alignRight: false, width: 150},
  {id: "accountDetail", label: "账户详情", alignRight: false, width: 200},
  {id: "childCount", label: "下级人数", alignRight: false, width: 80},
  {id: "roleLevel", label: "职级", alignRight: false, width: 100},
  {id: "status", label: "状态", alignRight: false, width: 80},
  {id: "blocked", label: "禁止登录", alignRight: false, width: 90},
  {id: "createdAt", label: "注册时间", alignRight: false, width: 140},
  {id: "action", label: "操作", alignRight: true, width: 80},
];

// 排序选项
const SORT_OPTIONS = [
  {value: "createdAt", label: "注册时间"},
  {value: "xfqV2", label: "权益金"},
  {value: "xfqV2Bak", label: "消费券"},
  {value: "dhqV2", label: "兑换券"},
  {value: "contributionValue", label: "系统贡献值"},
  {value: "pintuanContributionValue", label: "拼团贡献值"},
  {value: "childCount", label: "下级人数"},
  {value: "roleLevel", label: "职级"},
];

// 排序方式
const ORDER_OPTIONS = [
  {value: "asc", label: "正序"},
  {value: "desc", label: "倒序"},
];

const moreMenus = [
  {title: "编辑", icon: personOutline},
  // { title: "禁言", icon: personOutline },
  {title: "设置商城等级", icon: personOutline},
  {title: "设置渠道等级", icon: personOutline},
  {title: "设置权益金", icon: personOutline},
  {title: "留存权益金修改", icon: personOutline},
  {title: "设置积分", icon: personOutline},
  // {title: "设置添星券", icon: personOutline},
  {title: "积分互转", icon: personOutline},
  {title: "设置推荐人", icon: personOutline},
  {title: "开通推广码", icon: personOutline},
  {title: "重置登录密码", icon: personOutline},
  {title: "重置支付密码", icon: personOutline},
  {title: "拨付金银通VIP", icon: personOutline},
  {title: "资产转移", icon: personOutline},
  {title: "用户资产清算", icon: personOutline},
  {title: "注销账户", icon: personOutline},
];

export default function UserList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [targetUser, setTargetUser] = useState({});
  const [action, setAction] = useState("");
  
  // 用户限额详情弹窗
  const [userLimitDialogOpen, setUserLimitDialogOpen] = useState(false);
  const [userLimitInfo, setUserLimitInfo] = useState(null);
  const [userLimitLoading, setUserLimitLoading] = useState(false);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    uid: "",
    nickname: "",
    mobile: "",
    level: null,
    roleLevel: null,
    sort: null,
    order: null,
  });

  const [directorSet, setDirectorSet] = useState(new Set());
  const [directorDialog, setDirectorDialog] = useState({ open: false, row: null, isDirector: false, password: "" });

  useEffect(() => {
    getItems();
  }, [filter]);

  useEffect(() => {
    getDirectors();
  }, []);

  async function getItems() {
    const {data, count} = await asyncRequest({
      path: "/user/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  async function getDirectors() {
    const {data} = await asyncRequest({
      path: "/jingxi/allowance/director-list",
      data: {},
    });
    setDirectorSet(new Set(data?.uids || []));
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  function handleReset() {
    setFilter({
      page: 0,
      size: 10,
      search: "",
      uid: "",
      nickname: "",
      mobile: "",
    });
  }
  
  // 查看用户限额详情
  async function handleViewUserLimit(uid) {
    setUserLimitDialogOpen(true);
    setUserLimitLoading(true);
    setUserLimitInfo(null);
    
    try {
      // 使用管理后台专用接口
      const { data } = await asyncRequest({
        method: "GET",
        path: `/system/config/xfq-limit/user-info?uid=${uid}`,
      });
      
      setUserLimitInfo(data.userLimit);
    } catch (err) {
      console.error('获取用户限额信息失败:', err);
      alert(err?.message || err || '获取限额信息失败');
    } finally {
      setUserLimitLoading(false);
    }
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      navigate(`/user/edit/${row.uid}`, {state: row});
    } else if (type === "设置权益金") {
      setTargetUser(row);
      setAction("xfq");
    } else if (type === "留存权益金修改") {
      setTargetUser(row);
      setAction("xfqLocked");
    } else if (type === "设置商城等级") {
      setTargetUser(row);
      setAction("changeLevel");
    } else if (type === "设置渠道等级") {
      setTargetUser(row);
      setAction("changeRoleLevel");
    } else if (type === "充值入单") {
      setTargetUser(row);
      setAction("charge");
    } else if (type === "设置推荐人") {
      setTargetUser(row);
      setAction("bindParent");
    } else if (type === "开通推广码") {
      getInviteCode(row);
    } else if (type === "重置登录密码") {
      setTargetUser(row);
      setAction("resetPwd");
    } else if (type === "重置支付密码") {
      setTargetUser(row);
      setAction("resetPayPwd");
    } else if (type === "设置积分") {
      setTargetUser(row);
      setAction("points");
    } else if (type === "设置添星券") {
      setTargetUser(row);
      setAction("txq");
    } else if (type === "积分互转") {
      setTargetUser(row);
      setAction("pointsTransfer");
    } else if (type === "注销账户") {
      handleDestroy(row);
    } else if (type === "资产转移") {
      setTargetUser(row);
      setAction("merge");
    } else if (type === "用户资产清算") {
      setTargetUser(row);
      setAction("liquidate");
    } else if (type === "拨付金银通VIP") {
      setTargetUser(row);
      setAction("goldVip");
    } else if (type === "changeShowV1") {
      handleChangeShowV1(row);
    } else if (type === "设为董事") {
      handleSetDirector(row, true);
    } else if (type === "取消董事") {
      handleSetDirector(row, false);
    }
  };

  function handleSetDirector(row, isDirector) {
    setDirectorDialog({ open: true, row, isDirector, password: "" });
  }

  async function confirmSetDirector() {
    const { row, isDirector, password } = directorDialog;
    if (!password) return alert("请输入超管密码");

    await asyncRequest({
      path: "/jingxi/allowance/set-director",
      data: { uid: row.uid, isDirector, password },
    });

    setDirectorDialog({ open: false, row: null, isDirector: false, password: "" });
    getDirectors();
    alert(isDirector ? "已设为董事" : "已取消董事", "success");
  }

  function getInviteCode(row) {
    if (row.inviteCode) return alert("已经有推广码了");

    Confirm({
      message: "确定开通推广权限吗？",
      async onConfirm() {
        const {data} = await asyncRequest({
          path: "/user/getInviteCode",
          data: {uid: row.uid},
        });

        const item = items.find((it) => it.uid === row.uid);
        item.inviteCode = data;
        setItems([...items]);

        alert("开通成功", "success");
      },
    });
  }

  /**
   * 1.0数据展示开关切换
   * @param row 列数据
   */
  async function handleChangeShowV1(row) {
    await asyncRequest({
      path: "/user/changeShowV1",
      data: {uid: row.uid},
    });

    const item = items.find((it) => it.uid === row.uid);
    item.izShowV1 = !item.izShowV1;
    setItems([...items]);
  }

  function handleDestroy(row) {
    Confirm({
      message: "确定注销账户吗？",
      async onConfirm() {
        const {data} = await asyncRequest({
          path: "/user/destroy",
          data: {uid: row.uid},
        });

        getItems();

        alert("注销成功", "success");
      },
    });
  }

  async function toggleMuted(uid) {
    await asyncRequest({
      path: "/user/mute",
      data: {uid},
    });

    const item = items.find((it) => it.uid === uid);
    item.muted = !item.muted;
    setItems([...items]);
  }

  async function toggleBlocked(row) {
    const nextBlocked = !row.blocked;
    Confirm({
      message: nextBlocked ? "确定禁止该用户登录吗？开启后任意端、任意方式均无法登录。" : "确定解除禁止登录吗？",
      async onConfirm() {
        const {msg} = await asyncRequest({
          path: "/user/block",
          data: {uid: row.uid},
        });

        const item = items.find((it) => it.uid === row.uid);
        if (item) {
          item.blocked = nextBlocked;
          setItems([...items]);
        }
        alert(msg || (nextBlocked ? "已禁止登录" : "已解除禁止登录"), "success");
      },
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="用户列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            用户列表
          </Typography>

          <Button
            variant="contained"
            to="add"
            startIcon={<Icon icon={plusFill}/>}
            onClick={() => {
              setAction("addUser");
            }}
          >
            添加用户
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={(e) => handleFilterChange("search", e.target.value)}
                       onRefresh={getItems} onReset={handleReset}>
            <Grid container gap={1}>
              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{width: 200}}
                  label="用户ID"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                />
              </Grid>

              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{width: 200}}
                  label="昵称"
                  placeholder="昵称"
                  autoComplete="off"
                  id="nickname"
                  value={filter.nickname}
                  onChange={(e) => {
                    handleFilterChange("nickname", e.target.value);
                  }}
                />
              </Grid>

              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{width: 200}}
                  label="手机号"
                  placeholder="手机号"
                  autoComplete="off"
                  id="mobile"
                  value={filter.mobile}
                  onChange={(e) => {
                    handleFilterChange("mobile", e.target.value);
                  }}
                />
              </Grid>

              <Grid item sm={6} md={3}>
                <FormControl size="small">
                  <InputLabel>商城等级</InputLabel>
                  <Select
                    label="商城等级"
                    value={filter.level}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        level: e.target.value,
                      });
                    }}
                    style={{width: 250}}
                  >
                    {[null, ...levels].map((level, idx) => (
                      <MenuItem key={idx} value={level} name={level}>
                        {idx == 0 ? "全部" : USER_LEVEL_MAP[level]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item sm={6} md={3}>
                <FormControl size="small">
                  <InputLabel>渠道等级</InputLabel>
                  <Select
                    label="渠道等级"
                    value={filter.roleLevel}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        roleLevel: e.target.value,
                      });
                    }}
                    style={{width: 250}}
                  >
                    {[null, ...roleLevels].map((roleLevel, idx) => (
                      <MenuItem key={idx} value={roleLevel} name={roleLevel}>
                        {idx == 0 ? "全部" : ROLE_LEVEL_MAP[roleLevel]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>

          {/* 排序栏 */}
          <Box sx={{px: 2, py: 1, borderBottom: 1, borderColor: 'divider', backgroundColor: '#fafafa'}}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2" sx={{fontWeight: 'bold'}}>排序：</Typography>
              <FormControl size="small" sx={{minWidth: 120}}>
                <InputLabel>排序项</InputLabel>
                <Select
                  label="排序项"
                  value={filter.sort || ''}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      sort: e.target.value || null,
                      page: 0,
                    });
                  }}
                >
                  <MenuItem value="">请选择</MenuItem>
                  {SORT_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl size="small" sx={{minWidth: 100}}>
                <InputLabel>排序方式</InputLabel>
                <Select
                  label="排序方式"
                  value={filter.order || 'desc'}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      order: e.target.value,
                      page: 0,
                    });
                  }}
                >
                  {ORDER_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Box>

          <Scrollbar>
            <TableContainer sx={{minWidth: 800}}>
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>
                <TableBody>
                  {items.map((row) => {
                    const {
                      uid,
                      avatar,
                      nickname,
                      roleLevel,
                      realname,
                      xfqV2,
                      xfqV2Bak,
                      xfqLocked,
                      parent,
                      level,
                      childCount,
                      izShowV1,
                      status,
                      blocked,
                      createdAt,
                      mobile,
                      dhqV2,
                      contributionValue,
                      pintuanContributionValue,
                      convertibleQuota,
                      pintuanConvertibleQuota,
                    } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;
                    const isDirector = directorSet.has(uid);
                    const rowMenus = [...moreMenus, { title: isDirector ? "取消董事" : "设为董事", icon: personOutline }];
                    return (
                      <TableRow hover key={uid} tabIndex={-1} role="checkbox" selected={isItemSelected}
                                aria-checked={isItemSelected}>
                        <TableCell align="left" sx={{width: 120}}>
                          <Stack>
                            <Typography noWrap>
                              <Button
                                variant="text"
                                onClick={() => {
                                  setTargetUser(row);
                                  setAction("viewDetail");
                                }}
                              >
                                ID：{uid}
                              </Button>
                            </Typography>
                            <Typography noWrap>
                              <Button
                                variant="text"
                                onClick={() => {
                                  setTargetUser(row);
                                  setAction("viewDetail");
                                }}
                              >
                                手机号：{mobile}
                              </Button>
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{width: 150}}>
                          <UserInfo avatar={avatar} uid={uid} nickname={nickname} enablePreview/>
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{width: 150}}>
                          {!!parent && <UserInfo {...parent} />}
                        </TableCell>
                        {/* 账户详情列 */}
                        <TableCell align="left" sx={{width: 200}}>
                          <Stack spacing={0.5}>
                            <Stack direction="row" alignItems="center" spacing={0.5}>
                              <Typography noWrap variant="body2">权益金：{xfqV2 || 0}({xfqLocked || 0})</Typography>
                              <Tooltip title="查看当日权益金使用情况">
                                <IconButton size="small" onClick={() => handleViewUserLimit(uid)}>
                                  <InfoIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                            <Typography noWrap variant="body2">消费券：{xfqV2Bak || 0}</Typography>
                            <Typography noWrap variant="body2">兑换券：{dhqV2 || 0}</Typography>
                            <Typography noWrap
                                        variant="body2">系统贡献值：{Math.trunc(contributionValue || 0)}({convertibleQuota || 0}%)</Typography>
                            <Typography noWrap
                                        variant="body2">拼团贡献值：{Math.trunc(pintuanContributionValue || 0)}({pintuanConvertibleQuota || 0}%)</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left" sx={{width: 80}}>
                          <Link to={childCount ? `/user/parent/detail/${uid}` : ""}>{childCount}</Link>
                        </TableCell>
                        <TableCell align="left" sx={{width: 100}}>
                          {ROLE_LEVEL_MAP[roleLevel]}
                          {isDirector && <Label variant="ghost" color="warning" sx={{ml: 0.5}}>董事</Label>}
                        </TableCell>
                        <TableCell align="left" sx={{width: 80}}>
                          <Label variant="ghost" color={["error", "success", "error"][status]}>
                            {USER_STATUS_MAP[status]}
                          </Label>
                        </TableCell>
                        <TableCell align="left" sx={{width: 90}}>
                          <Switch
                            checked={!!blocked}
                            color="error"
                            onChange={() => toggleBlocked(row)}
                          />
                        </TableCell>
                        <TableCell align="left"
                                   sx={{width: 140}}>{moment(createdAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                        <TableCell align="right" sx={{width: 80}}>
                          <Stack direction="row">
                            <MoreMenu spread={false} menus={rowMenus}
                                      onMoreClick={(type) => handleMoreClick(type, row)}/>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{py: 5}}>
                        <SearchNotFound searchQuery={filter.search}/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange}/>
        </Card>
      </Container>

      <XfqTopupDialog
        open={action === "xfq"}
        onClose={() => setAction("")}
        onFinish={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      />

      <XfqLockedTopupDialog
        open={action === "xfqLocked"}
        onClose={() => setAction("")}
        onFinish={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      />

      <TxqTopupDialog
        open={action === "txq"}
        onClose={() => setAction("")}
        onFinish={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      />
      <PointTopupDialogTwo
        open={action === "pointsTransfer"}
        onClose={() => setAction("")}
        onFinish={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      />

      <PointTopupDialog
        open={action === "points"}
        onClose={() => setAction("")}
        onFinish={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      />

      {action === "addUser" && (
        <UserAddDialog
          open
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
        />
      )}

      {action === "bindParent" && (
        <BindUserParentDialog
          open
          onClose={() => setAction("")}
          onReload={() => {
            getItems();
            setAction("");
          }}
          user={targetUser}
        />
      )}

      {action === "merge" && (
        <UserMergeDialog
          open
          onClose={() => setAction("")}
          onReload={() => {
            getItems();
            setAction("");
          }}
          user={targetUser}
        />
      )}

      {action === "changeLevel" && (
        <ChangeUserLevelDialog
          open
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
          user={targetUser}
        />
      )}

      {action === "changeRoleLevel" && (
        <ChangeRoleLevelDialog
          open
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
          user={targetUser}
        />
      )}

      {action == "viewDetail" &&
        <UserInfoDrawer open uid={targetUser.uid} avatar={targetUser.avatar} nickname={targetUser.nickname}
                        onClose={() => setAction("")}/>}

      {action === "resetPwd" && <ResetUserPwdDialog open={true} user={targetUser} onClose={() => setAction("")}/>}
      {action === "resetPayPwd" && <ResetUserPayPwdDialog open={true} user={targetUser} onClose={() => setAction("")}/>}

      {action === "liquidate" && (
        <UserLiquidateDialog
          open
          user={targetUser}
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
        />
      )}

      {action === "goldVip" && (
        <GoldVipTopupDialog
          open
          user={targetUser}
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
        />
      )}
      
      {/* 用户限额详情弹窗 */}
      <Dialog open={userLimitDialogOpen} onClose={() => setUserLimitDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>当日权益金使用情况</DialogTitle>
        <DialogContent>
          {userLimitLoading ? (
            <Stack alignItems="center" justifyContent="center" sx={{ py: 4 }}>
              <CircularProgress />
            </Stack>
          ) : userLimitInfo ? (
            <Stack spacing={2}>
              {userLimitInfo.limitEnabled ? (
                <>
                  <Typography variant="body1">
                    <strong>单笔限额：</strong>{userLimitInfo.singleLimit.toFixed(2)} 元
                  </Typography>
                  <Typography variant="body1">
                    <strong>单日限额：</strong>{userLimitInfo.dailyLimit.toFixed(2)} 元
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    <strong>当日已用：</strong>{userLimitInfo.todayUsed.toFixed(2)} 元
                  </Typography>
                  <Typography variant="body1" color="success.main">
                    <strong>当日剩余：</strong>{userLimitInfo.remainingLimit.toFixed(2)} 元
                  </Typography>
                </>
              ) : (
                <Typography variant="body1" color="text.secondary">
                  当前未开启用户权益金限额
                </Typography>
              )}
            </Stack>
          ) : (
            <Typography variant="body1" color="text.secondary">
              暂无数据
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUserLimitDialogOpen(false)}>关闭</Button>
        </DialogActions>
      </Dialog>

      {/* 设为/取消董事弹窗 */}
      <Dialog open={directorDialog.open} onClose={() => setDirectorDialog({...directorDialog, open: false})} maxWidth="xs" fullWidth>
        <DialogTitle>{directorDialog.isDirector ? "设为董事" : "取消董事"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{pt: 1}}>
            <Typography variant="body2">
              {directorDialog.isDirector
                ? `确定将用户 ${directorDialog.row?.nickname || directorDialog.row?.uid || ""} 设为董事吗？`
                : `确定取消用户 ${directorDialog.row?.nickname || directorDialog.row?.uid || ""} 的董事身份吗？`}
            </Typography>
            <TextField
              size="small"
              label="超管密码"
              type="password"
              fullWidth
              autoFocus
              value={directorDialog.password}
              onChange={(e) => setDirectorDialog({...directorDialog, password: e.target.value})}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDirectorDialog({...directorDialog, open: false})}>取消</Button>
          <Button variant="contained" onClick={confirmSetDirector}>确定</Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
